import BaseComponent from '../../base/base_component';
import Model from './radio_button_model';
import DOM from "../../utils/dom";
import Device from "../../utils/device";
import {RADIO_BUTTON_SELECTORS} from './radio_button_consts';

let radioButtonView = require('./view/radio_button.html');

class RadioButtonComponent extends BaseComponent {
	/**
	 * @static
	 * @type {string}
	 */
	static CLASS = 'RadioButtonComponent';


	/**
	 * @static
	 * @type {string}
	 */
	static DIRECTIVE = 'cgp-directive-radioButton';


	/**
	 * @property
	 * @type {object|null}
	 * @private
	 */
	_model = null;


	_elementMap = {};

	/**
	 *
	 */
	init(params) {
		super.init();
		this._model = Model.create(params);
	}


	/**
	 *
	 * @returns {ItalyGameLimitMessageComponent}
	 */
	start() {
		let bakedHTML = this.bake(radioButtonView, {});

		this
			.setHTML(bakedHTML)
			._applyDeviceCSS()
			._mapElements()
			._configureRB();

		return this;
	}

	_applyDeviceCSS() {
		if (Device.isFirefox()) {
			let firefoxVersion = parseInt(Device.getUserAgent().toLowerCase().match(/firefox\/([0-9]+)\./)[1], 10);
			if(!isNaN(firefoxVersion) && (firefoxVersion<60)) {
				DOM.addClass(this.getEl(), 'cgp-radio-ie-moz-fix');
			}
		}

		return this;
	}


	_mapElements() {
		let view = this.getEl();

		this._elementMap = {
			rbNormal: view.querySelector(RADIO_BUTTON_SELECTORS.NORMAL),
			rbSelected: view.querySelector(RADIO_BUTTON_SELECTORS.SELECTED),
			rbLabel: view.querySelector(RADIO_BUTTON_SELECTORS.LABEL),
			rbInput: view.getElementsByTagName('input')[0]
		};

		return this;
	}


	_configureRB() {
		if (this._model.getID() !== '') {
			DOM.addAttribute(this._elementMap.rbInput, 'id', this._model.getID());
		}

		if (this._model.getName() !== '') {
			DOM.addAttribute(this._elementMap.rbInput, 'name', this._model.getName());
		}

		if (this._model.isChecked()) {
			DOM.addAttribute(this._elementMap.rbInput, 'checked');
		}

		DOM.html(this._model.getLabel(), this._elementMap.rbLabel);

		return this;
	}
}

export default RadioButtonComponent;